<template>
  <div class="w-1/2 mx-auto">
    <label>
      File
      <input class="w-full" type="file" id="file" ref="file" v-on:change="onChangeFileUpload()" />
    </label>
    <br />
    <div class="w-full mx-auto pt-4">
      <vs-button v-on:click="submitForm()">Upload</vs-button>
    </div>
    <div v-if="bverify" class="w-full mx-auto pt-4">
      <vs-input disabled class="inputx w-full" v-model="filename" />
      <div class="pt-4">
        <vs-button @click="onbverify">Verify</vs-button>
        <vs-progress v-if="progress" indeterminate color="primary">primary</vs-progress>
      </div>
    </div>
    <div v-if="verify" class="w-full mx-auto pt-4">
      <vs-input v-if="verify" class="inputx w-1/2 pb-4" label-placeholder="Reference Number" v-model="declaration" />
      <vs-input v-if="verify" class="inputx w-1/3 pb-4" v-model="ardate" label-placeholder="Date" v-mask="'####-##-##'" />
      <br>
      <b-table :data="data" :columns="columns"></b-table>
      <div class="pt-4">
        <vs-button @click="onverify">Confirm</vs-button>
        <vs-progress v-if="progress" indeterminate color="primary">primary</vs-progress>
      </div>
    </div>
  </div>
</template>
<style scoped>
img {
  max-height: 36px;
}
</style>
<script>
import axios from "../axios_app";

export default {
  data() {
    return {
      file: "",
      bverify: false,
      verify: false,
      progress: false,
      filename: null,
      declaration: null,
      ardate:null,
      hawb:null,
      data: [],
      columns: [
        {
          field: "item",
          label: "Item",
          width: "40",
          numeric: true,
        },
        {
          field: "hbl",
          label: "HouseBl",
        },
        {
          field: "qty",
          label: "TotalPackage",
          width: "40",
          numeric: true,
        },
        {
          field: "qtyunit",
          label: "Unit",
          centered: true,
        },
      ],
    };
  },
  methods: {
    onbverify() {
      let vm = this;
      this.progress = true;
      let formData = {
        filename: this.filename,
        token: localStorage.getItem("token"),
        token2: localStorage.getItem("token2"),
        dbname: localStorage.getItem("dbname")
      };

      axios
        .post("/ApiBInbUpVerify", formData)
        .then(res => {
          // console.log(res.data.message);
          if (res.data.status == "false") {
            vm.$vs.notify({
              title: "Upload",
              text: res.data.message,
              color: "danger",
              position: "top-right",
              fixed: true
            });
          } else {
            vm.$vs.notify({
              title: "Verify",
              text: "Verify Complete",
              color: "success",
              position: "top-right",
              time: 3000
            });
            if (res.data.message != undefined) {
              vm.declaration = res.data.message[0];
              vm.ardate = res.data.ardate[0];
              vm.data = res.data.data;
              vm.hawb = res.data.data[0].hbl;
              // console.log(res.data.data[0].hbl);
            } else {
              let todayDate = new Date().toISOString().slice(0,10);
              // console.log(todayDate);
              vm.declaration = "";
              vm.ardate = todayDate;
              vm.hawb = "";
            }
            vm.verify = true;
          }
          vm.progress = false;
        })
        .catch(err => {
          // console.log(err);
          vm.$vs.notify({
            title: "Upload",
            text: err,
            color: "danger",
            position: "top-right",
            fixed: true
          });
        });
    },
    onverify() {
      let vm = this;
      // console.log(this.declaration);
      if (this.declaration == "" || this.ardate == "") {
        vm.$vs.notify({
          title: "Upload",
          text: "Please Enter All Information",
          color: "danger",
          position: "top-right",
          time: 3000
        });
      } else {
        this.progress = true;
        let formData = {
          filename: this.filename,
          declaration: this.declaration,
          ardate: this.ardate,
          hawb: this.hawb,
          token: localStorage.getItem("token"),
          token2: localStorage.getItem("token2"),
          dbname: localStorage.getItem("dbname"),
          comgroups_id: localStorage.getItem("comgroups_id"),

        };

        axios
          .post("/ApiInbUpVerify", formData)
          .then(res => {
            // console.log(res.data.message);
            if (res.data.status == "false") {
              vm.$vs.notify({
                title: "Upload",
                text: res.data.message,
                color: "danger",
                position: "top-right",
                fixed: true
              });
            } else {
              vm.$vs.notify({
                title: "Upload",
                text: res.data.message,
                color: "success",
                position: "top-right",
                time: 3000
              });
            }

            vm.progress = false;
            vm.$emit("done");
          })
          .catch(err => {
            // console.log(err);
            vm.$vs.notify({
              title: "Upload",
              text: err,
              color: "danger",
              position: "top-right",
              fixed: true
            });
          });
      }
    },
    submitForm() {
      let vm = this;
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("token", localStorage.getItem("token"));
      formData.append("token2", localStorage.getItem("token2"));
      formData.append("dbname", localStorage.getItem("dbname"));
      formData.append("comgroups_id", localStorage.getItem("comgroups_id"));

      axios
        .post("/ApiInbUpload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(res) {
          // console.log(data.data.filename);
          if (res.data.status == "false") {
            vm.$vs.notify({
              title: "Upload",
              text: res.data.message,
              color: "danger",
              position: "top-right",
              fixed: true
            });
          } else {
            vm.bverify = true;
            vm.filename = res.data.filename;

            vm.$vs.notify({
              title: "Upload",
              text: res.data.message,
              color: "success",
              position: "top-right",
              time: 3000
            });
          }
        })
        .catch(function() {
          // console.log("FAILURE!!");
          vm.$vs.notify({
            title: "Upload",
            text: "FAILURE!!",
            color: "danger",
            position: "top-right",
            fixed: true
          });
        });
    },

    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
    }
  }
};
</script>
